import React, { useState, useEffect, Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetDeclarationAction,
  SetActiveTabs,
  SetDeclarationcreateAction,
  settheDataFetchActions,
  SetEsiFormIdActions, ///Esi ID Action Call
  SetDeclarationEditAction,
  setTheOnboardPhoneNumber, // for get the phone number
} from "../../../Redux/Slice";
import validator from "validator";
import ReactCrop from "react-image-crop";
import Select from "react-select";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import "react-image-crop/dist/ReactCrop.css";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import axios from "axios";

const DecalarationFrom = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const isAdminEmails =
    state.SideBarFiles?.UserEmailID === "codoid@gmail.com" ||
    state.SideBarFiles?.UserEmailID === "admin@uds.in" ||
    state.SideBarFiles?.UserEmailID === "admin@gmail.com" ||
    state.SideBarFiles?.UserEmailID === "adminit@uds.in";

  const shouldMask =
    Boolean(state.EmployeeProfile?.EmployeeProfileList?.payroll_approved) &&
    !isAdminEmails;
  const UserData = useSelector((state) => state.users.UserData.data);

  const initialState = {
    employee_name: "",
    spouse_name: "",
    email: "",
    mobile_no: "",
    father_name: "",
    gender: "",
    marital_status: "unmarried",
    aadhar_number: "",
    bank_acc_ifsc: "",
    date_of_birth: "",
    pan_number: "",
    origin_country: "",
    passport_number: "",
    passport_validity_from: null,
    passport_validity_to: null,
    pf_acc_number: "",
    previous_end_date: "",
    universal_acc_number: "",
    ppo_number: "",
    scheme_number: "",
    is_international: false,
    // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
    timeline_id: state.BasicFormCreated.BasciFormCreate,
    relation_name: "",
    relation: "",
    provident_fund_schema: false,
    pension_schema: false,
    //timeline_id: ids,
    ifsc_code: "",
    is_uan_number: true,
  };
  const [data, setData] = useState(initialState);

  // console.log(
  //   state.BasicFormCreated.BasciFormCreate,
  //   "BasciFormCreate",
  //   data,
  //   state.FormsIDList.ActiveTabs
  // );
  const [email, setemail] = useState("");
  const [BankNaErr, setBankErr] = useState("");
  const [DeclaationPassfile, setdeclarationPassFile1] = useState();
  const [EmailID, setEmailID] = useState("");

  // console.log(data, "data");
  const formdatas = new FormData();
  const [empNameerr, setEmpNaErr] = useState("");
  const [spouseNaErr, spouseErr] = useState("");
  const [emailERr, setemalErr] = useState("");
  const [mobileNumErr, setMobilErr] = useState("");
  const [FatherErr, setFatherErr] = useState("");
  const [genderErr, setGrnderErr] = useState("");
  const [maritalStErr, setMatriErr] = useState("");
  const [AAdErr, setAadhar] = useState("");
  const [Bacnk_IFErr, setBankIfcEr] = useState("");
  const [DateERr, setDateErr] = useState("");
  const [panNmErr, setPAnNumErr] = useState("");
  const [passportNerr, setPassNEr] = useState("");
  const [passportValidERr, setpassPortVaERr] = useState("");
  const [passportValidERrT, setpassPortVaERrT] = useState("");
  const [PFErr, setPFerr] = useState("");
  const [previouerr, setpreviouserr] = useState("");
  const [universalErr, setUniversalerr] = useState("");
  const [PPOErr, setPPoErr] = useState("");
  const [schemeErr, setScheErr] = useState("");
  const [origonErr, setOriginEr] = useState("");
  const [isinternationErr, setInterNationErr] = useState();
  const [uanerror, setuanerror] = useState("");
  // console.log(data, "is_internations");
  const [FamilyOptions, setFamliyOptions] = useState([
    // { value: "father", label: "Father" },
    // { value: "mother", setValidated: "Mother" },
    // { value: "spouse", label: "Spouse" },
    // { value: "son", label: "Son" },
    // { value: "daughter", label: "Daughter" },
    // { value: "guardian", label: "Guardian" },
    { value: "FATHER", label: "FATHER" },
    { value: "MOTHER", label: "MOTHER" },
    { value: "SPOUSE", label: "SPOUSE" },
    { value: "SON", label: "SON" },
    { value: "DAUGHTER", label: "DAUGHTER" },
    { value: "GUARDIAN", label: "GUARDIAN" },
  ]);

  ///---present---url
  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState({
    file: "",
    url: "",
  });

  const [ErrorInde, setErrInde] = useState(0);
  const fileInputRef = useRef();
  const [selectedName, setSelectName] = useState();
  const [selectedEducation, setSelectedEducation] = useState([]);
  const [SelectOptions, setSelectedoptions] = useState([]);
  const [display, setDisplay] = useState(false);
  const [NameErr, setNameErr] = useState();
  const [inputFields, setInputFields] = useState([
    {
      person_name: data.relation_name,
    },
  ]);
  ///---Capital---word--
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const [selectedfamRe, setselectFam] = useState();

  const [url, setUrl] = useState();

  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const [file, setImageField] = useState([]);
  const [ImageFieldUrl, setImageFieldurl] = useState({ frontImage: "" });
  const [BankImageCAnUplo, setBankUplo] = useState(false);
  const imgRef = useRef(null);
  const [IFSErr, setIfsErr] = useState("");

  const [crop, setCrop] = useState();
  // {
  //   unit: '%', // Can be 'px' or '%'
  //   x: 0,
  //   y: 0,
  //   width: 100,
  //   height: 100,
  // }
  // console.log(CroppImageView , "9384239pjiiCroppImageView");
  const organization = useSelector(
    (state) => state.NumberCounts.selectedOnoardClient,
  );

  const isAthena = organization?.organization?.id === "28e108e0-a644-4365-89df-317867f00f22";
  const isDenave = organization?.organization?.id === "11a8ab83-0669-4098-a453-ddb2a2e0c39e";
  const empType = state?.EmployeeProfile?.EmployeeProfileList?.basic_info?.employee_type;

  const isUanRequired =
    Boolean(data?.is_uan_number) &&
    !isDenave &&
    (!isAthena || empType == "6");

  const Options = [
    {
      // id: 1,

      value: "unmarried",
      label: "UNMARRIED",
    },
    {
      // id: 2,
      value: "married",
      label: "MARRIED",
    },
    {
      // id: 3,
      value: "others",
      label: "OTHERS",
    },
  ];

  const [MaterilStatus, setMaritalStatus] = useState({
    // id: 1,

    value: "unmarried",
    label: "UNMARRIED",
  });

  useEffect(() => {
    if (UserData != undefined) {
      if (
        UserData.admin_access != undefined &&
        UserData.admin_access != "" &&
        UserData.admin_access != null &&
        UserData.admin_access != undefined
      ) {
        console.log(UserData.email, "927309UserData");
        setEmailID(UserData.email);
      }
    }
  }, [state.users.UserData.data]);

  const [GEDNDER, setGEnder] = useState(data.gender);
  useEffect(() => {
    if (data.gender != undefined && data.gender != null && data.gender != "") {
      setGEnder(capitalizeFirstLetter(data.gender.toLowerCase()));
    }
  }, [data.gender]);

  // console.log(data , "2370qs9eud9",state.DeclarationCall.Decalarationdatat.is_international);

  const fixedCropSize = { width: 300, height: 200 };
  const cancel = (e) => {
    setalert(true);

    setImageField("");
    setUrl("");
    seturlandfile({
      url: "",
    });
    setBankUplo(false);
    setPresentUrls([]);
  };

  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false);
          }, 0);
          setPresentUrls([]);

          const generateRandomNumber = () => {
            return Math.floor(Math.random() * 100000);
          };
          setBankUplo(true);

          const createPresentData = (croppedFile) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `onboarding/passport/passport${randomNumber}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
            const Presentdata = {
              multiple_files: [
                {
                  filename: formattedFilename,
                  file_type: croppedFile.type,
                },
              ],
            };

            return Presentdata;
          };

          const Presentdata = createPresentData(croppedFile);

          axios({
            url: PresentUrl,
            method: "post",
            data: Presentdata,
            headers: {
              Authorization:
                "Bearer " + store.getState().users.UserData.session.token,
            },
          })
            .then((response) => {
              console.log("Files uploaded successfully:", response.data);
              const uploadedFiles = response.data.data; // Adjust based on actual response structure
              console.log(uploadedFiles, "uploadedFiles");

              const newUrls = uploadedFiles.map((file) => ({
                url: file, // Adjust this based on the actual response
                type: croppedFile.type,
                putfiles: croppedFile,
              }));

              // Update PresentUrls state
              setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);
              seturlandfile({
                url: String(response.data.data).split("?")[0],
              });
            })
            .catch((error) => {
              console.error("Error uploading files:", error);
            });
        }

        // if (CroppImageViewCount == 1) {
        setImageField((oldArray) => [...oldArray, croppedFile]);
        var file = croppedFile;
        var reader = new FileReader();
        reader.onloadend = function () {
          setUrl(reader.result);
        };
        reader.readAsDataURL(file);
        // }
        // console.log(croppedFile);
        blob.name = fileName;
        resolve(croppedFile);
      }, "image/jpeg");
    });
  }

  const selectedImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };


  const handleFiles = (e) => {
    setCroppImageView(true);
    setdeclarationPassFile1(e);
    setCroppImageViewCount(1);
    setalert(true);

    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    const MIN_DIMENSION = 150;

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(e); // Continue processing the image
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }
  };

  const updateAvatar = (imgSrc) => {
    fileInputRef.current.value = imgSrc;
  };

  const HandleAddingChanges = (e) => {
    if (e != null) {
      setSelectName(e.value);

      // setData({
      //   ...data,
      //   relation: e.value.toLowerCase(),
      // });
      setselectFam(e);
      // console.log(e, "relationsdsd", state.FamilyList.FamilyDetails);

      // state.FormsIDList.FamilyDetailsId !== "" &&
      //   state.FamilyList.FamilyDetails !== undefined &&
      //   state.FamilyList.FamilyDetails !== null &&
      //   state.FamilyList.FamilyDetails.map((item, index) => {
      //     if (item.person_name != undefined && item.person_name != null) {
      //       if (item.person_type.toUpperCase() == e.label.toUpperCase()) {
      //         const values = [...inputFields];

      //         values[index].person_name = item.person_name.toUpperCase();
      //         setData({
      //           ...data,
      //           relation_name: item.person_name.toUpperCase(),
      //         });

      //         setInputFields(values);
      //       }
      //     }
      //   });

      setSelectedoptions((prevState) => [...prevState, e]);

      // console.log(FamilyOptions ,"FamliyOptions", setFamliyOptions((prevOptions) =>
      // prevOptions.filter((option) => option.value !== e.value)));
      setSelectedEducation((prevState) => [...prevState, e]);
    }
  };

  const inputRef = useRef(null);

  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");

    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, "");

    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  // const handleAddFields = (e) => {
  //   //   console.log(e.value, "asdas");
  //   if (e != null) {
  //     var values;
  //     if (e.value != null) {
  //       values = [...inputFields];
  //       values.push({
  //         person_name: "",
  //       });

  //       setFamliyOptions((prevOptions) =>
  //         prevOptions.filter((option) => option.value !== e.value.toLowerCase())
  //       );
  //     }
  //     setInputFields(values);
  //   }
  // };

  const handleAddFields = (e) => {
    if (e != null) {
      var values = [...inputFields];
      values.push({
        person_name: "",
      });

      setFamliyOptions((prevOptions) =>
        prevOptions.filter((option) => option.value !== e.value),
      );

      setInputFields(values);
    }
  };

  // const handleRemoveFields = (index) => {
  //   const values = [...inputFields];
  //   console.log(values, "values");

  //   // Get the element to be removed
  //   var removedElement = values[index];
  //   console.log(removedElement, "removedElement", removedElement.person_name);

  //   // Slice the array to remove the element
  //   const slicedValues = values.slice(0, index).concat(values.slice(index + 1));
  //   console.log(slicedValues, "slicedValues");
  //   setInputFields(slicedValues);

  //   // setFamliyOptions((prevOptions) => [
  //   //   ...prevOptions,
  //   //   {
  //   //     value: capitalizeFirstLetter(removedElement.person_name),
  //   //     label: capitalizeFirstLetter(removedElement.person_name),
  //   //   },
  //   //   SelectOptions,
  //   // ]);

  //   // Now you can perform any further operations with the removed element or the sliced array
  // };

  // const handleRemoveFields = (index) => {
  //   const values = [...inputFields];
  //   console.log(values, "values");

  //   // Get the element to be removed
  //   var removedElement = values[index];
  //   console.log(removedElement, "removedElement", removedElement.person_name);

  //   // Slice the array to remove the element
  //   const slicedValues = values.slice(0, index).concat(values.slice(index + 1));
  //   console.log(slicedValues, "slicedValues");
  //   setInputFields(slicedValues);

  //   // Find the corresponding option based on the person_name
  //   const removedOption = {
  //     value: removedElement.person_name.toUpperCase(),
  //     label: removedElement.person_name.toUpperCase()
  //   };

  //   // Add the removed option back to the FamilyOptions array
  //   setFamliyOptions((prevOptions) => [...prevOptions, removedOption]);
  // };

  // console.log(data ,"019832901jmed");

  const handleRemoveFields = (index) => {
    setselectFam(null);
    setData({
      ...data,
      relation_name: "",
      relation: "",
    });

    var removedOption;
    setDisplay(false);

    const values = [...inputFields];
    // console.log(values, "values");

    // Get the element to be removed
    var removedElement = values[index];
    console.log(selectedfamRe, "removedElement", removedElement.person_name);

    // Slice the array to remove the element
    const slicedValues = values.slice(0, index).concat(values.slice(index + 1));
    // console.log(slicedValues, "slicedValues");
    setInputFields(slicedValues);

    // Find the corresponding option based on the person_name
    if (
      selectedfamRe != null &&
      selectedfamRe.value != undefined &&
      selectedfamRe.label != undefined
    ) {
      removedOption = {
        value: selectedfamRe.value.toUpperCase(),
        label: selectedfamRe.label.toUpperCase(),
      };
    }

    // Add the removed option back to the FamilyOptions array
    setFamliyOptions((prevOptions) => {
      const isOptionExists = prevOptions.some(
        (option) => option.value === removedOption.value,
      );
      if (!isOptionExists) {
        return [...prevOptions, removedOption];
      }
      return prevOptions;
    });
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === "person_name") {
      values[index].person_name = event.target.value.toUpperCase().trim();
      setData({
        ...data,
        relation_name: event.target.value.toUpperCase().trim(),
      });
    }
    setInputFields(values);
  };

  useEffect(() => {
    if (
      state.FormsIDList.DecalarationID != "" &&
      state.FormsIDList.ActiveTabs == 8
    ) {
      const payload = {
        Retieveid: state.FormsIDList.DecalarationID,
      };
      dispatch(SetDeclarationAction(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  const HandleChanges = (e, Values) => {
    console.log("293898", "Others", e.target.value);
    if (e.target.name == "pan_number") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value.slice(0, 10),
      });
    }

    if (e.target.name == "aadhar_number") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value.slice(0, 12),
      });
      console.log(value.slice(0, 12), "aadhar valuesd", data);
    }
    if (e.target.name == "mobile_no") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value.slice(0, 10),
      });
    }
    if (e.target.name == "gender") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value,
      });
    }

    if (e.target.name == "is_international") {
      console.log(Values, "Val239480923ues");
      const { name, value } = e.target;
      if (Values == true) {
        setData({
          ...data,
          is_international: Values,
        });
      } else {
        setData({
          ...data,
          origin_country: "",
          passport_validity_from: null,
          passport_number: "",
          passport_validity_to: null,
        });
      }
    }

    if (e.target.name == "is_international") {
      // console.log(Values, "Values");
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: Values,
      });
    } else {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value.toUpperCase().trim(),
      });
    }
  };

  useEffect(() => {
    if (
      // state.FormsIDList.DecalarationID ==
      //   state.DeclarationCall.Decalarationdatat.id &&
      state.FormsIDList.DecalarationID != "" &&
      state.DeclarationCall.Decalarationdatat != undefined
    ) {
      setData({
        ...data,
        employee_name: state.DeclarationCall.Decalarationdatat.employee_name,
        spouse_name: state.DeclarationCall.Decalarationdatat.spouse_name,
        mobile_no: state.DeclarationCall.Decalarationdatat.mobile_no,
        email: state.DeclarationCall.Decalarationdatat.email,
        father_name: state.DeclarationCall.Decalarationdatat.father_name,
        gender: state.DeclarationCall.Decalarationdatat.gender,
        marital_status: state.DeclarationCall.Decalarationdatat.marital_status,

        aadhar_number: state.DeclarationCall.Decalarationdatat.aadhar_number,
        bank_acc_ifsc: state.DeclarationCall.Decalarationdatat.bank_acc_ifsc,
        ifsc_code: state.DeclarationCall.Decalarationdatat.ifsc_code,
        // bank_acc_ifsc: state.DeclarationCall.Decalarationdatat.bank_acc_ifsc,
        date_of_birth: state.DeclarationCall.Decalarationdatat.date_of_birth,
        pan_number: state.DeclarationCall.Decalarationdatat.pan_number,
        origin_country: state.DeclarationCall.Decalarationdatat.origin_country,
        passport_number:
          state.DeclarationCall.Decalarationdatat.passport_number,
        passport_validity_from:
          state.DeclarationCall.Decalarationdatat.passport_validity_from,

        passport_validity_to:
          state.DeclarationCall.Decalarationdatat.passport_validity_to,
        pf_acc_number: state.DeclarationCall.Decalarationdatat.pf_acc_number,
        previous_end_date:
          state.DeclarationCall.Decalarationdatat.previous_end_date,
        universal_acc_number:
          state.DeclarationCall.Decalarationdatat.universal_acc_number,

        ppo_number: state.DeclarationCall.Decalarationdatat.ppo_number,
        scheme_number: state.DeclarationCall.Decalarationdatat.scheme_number,
        is_international:
          state.DeclarationCall.Decalarationdatat.is_international,
        relation_name: state.DeclarationCall.Decalarationdatat.relation_name,
        relation: state.DeclarationCall.Decalarationdatat.relation,
        pension_schema: state.DeclarationCall.Decalarationdatat.pension_schema,
        provident_fund_schema:
          state.DeclarationCall.Decalarationdatat.provident_fund_schema,
        // is_uan_number:state.DeclarationCall.Decalarationdatat.is_uan_number,
        is_uan_number: true,
      });

      if (state.DeclarationCall.Decalarationdatat.marital_status != undefined) {
        setMaritalStatus({
          value: state.DeclarationCall.Decalarationdatat.marital_status,
          label:
            state.DeclarationCall.Decalarationdatat.marital_status.toUpperCase(),
        });
      }
      setemail(
        state.DeclarationCall.Decalarationdatat.email != null &&
          state.DeclarationCall.Decalarationdatat.email != undefined &&
          state.DeclarationCall.Decalarationdatat.email != ""
          ? state.DeclarationCall.Decalarationdatat.email
          : "",
      );

      if (
        state.DeclarationCall.Decalarationdatat.relation != null &&
        state.DeclarationCall.Decalarationdatat.relation != undefined &&
        state.DeclarationCall.Decalarationdatat.relation != ""
      ) {
        setselectFam({
          value: state.DeclarationCall.Decalarationdatat.relation,
          label: capitalizeFirstLetter(
            state.DeclarationCall.Decalarationdatat.relation,
          ),
        });
        setDisplay(true);
        const values = [];

        values.push({
          person_name: state.DeclarationCall.Decalarationdatat.relation_name,
        });

        setInputFields(values);
      }

      if (
        state.DeclarationCall.Decalarationdatat != undefined &&
        state.DeclarationCall.Decalarationdatat.passport_id != undefined &&
        state.DeclarationCall.Decalarationdatat.passport_id != null &&
        state.DeclarationCall.Decalarationdatat.passport_id.media_url !=
        undefined &&
        state.DeclarationCall.Decalarationdatat.passport_id.media_url != ""
      ) {
        setUrl(state.DeclarationCall.Decalarationdatat.passport_id.media_url);
        seturlandfile({
          url: state.DeclarationCall.Decalarationdatat.passport_id.media_url,
        });
      }
    }
  }, [state.DeclarationCall, state.FormsIDList.ActiveTabs]);

  // console.log(state.BasicFormCreated.BacicDatas.user_id , "user_ID");

  useEffect(() => {
    ////---data---fetch
    if (
      state.FormsIDList.BasicFormID != "" &&
      state.FormsIDList.ActiveTabs == 8 &&
      state.NumberCounts.Editable != 1
    ) {
      const payload = {
        user_id: state.BasicFormCreated.user_ID,
        //  user_id:state.BasicFormCreated.BacicDatas.user_id,
      };
      dispatch(settheDataFetchActions(payload));
    }
  }, [state.FormsIDList.BasicFormID]);

  useEffect(() => {
    if (
      state.FormsIDList.DecalarationID == "" &&
      state.FormsIDList.BasicFormID != "" &&
      state.FormsIDList.ActiveTabs == 8 &&
      state.DatafetchCall.DataFetchDatass != undefined
    ) {
      setemail(
        state.DatafetchCall.DataFetchDatass.email_id != null &&
          state.DatafetchCall.DataFetchDatass.email_id != undefined &&
          state.DatafetchCall.DataFetchDatass.email_id != ""
          ? state.DatafetchCall.DataFetchDatass.email_id
          : "",
      );
      setData({
        ...data,
        employee_name: state.DatafetchCall.DataFetchDatass.first_name,
        // spouse_name: state.DatafetchCall.DataFetchDatass.spouse_name,
        mobile_no: state.DatafetchCall.DataFetchDatass.phone_number,
        email: state.DatafetchCall.DataFetchDatass.email_id,
        father_name: state.DatafetchCall.DataFetchDatass.father_name,
        gender: state.DatafetchCall.DataFetchDatass.gender,
        // marital_status: state.DatafetchCall.DataFetchDatass.marital_status,

        aadhar_number: state.DatafetchCall.DataFetchDatass.aadhar_number,
        bank_acc_ifsc: state.DatafetchCall.DataFetchDatass.account_number,
        ifsc_code: state.DatafetchCall.DataFetchDatass.ifsc_code,

        date_of_birth: state.DatafetchCall.DataFetchDatass.date_of_birth,
        pan_number:
          state.DatafetchCall.DataFetchDatass.pan_number != undefined &&
            state.DatafetchCall.DataFetchDatass.pan_number != null
            ? state.DatafetchCall.DataFetchDatass.pan_number
            : "",
        // origin_country: state.DatafetchCall.DataFetchDatass.origin_country,
        passport_number: state.DatafetchCall.DataFetchDatass.passport_number,
        is_international: false,
        // passport_validity_from:

        // state.DatafetchCall.DataFetchDatass.passport_validity_from,

        // passport_validity_to:
        // state.DatafetchCall.DataFetchDatass.passport_validity_to,
        // pf_acc_number: state.DeclarationCall.Decalarationdatat.pf_acc_number,
        // previous_end_date:
        // state.DatafetchCall.DataFetchDatass.previous_end_date,
        // universal_acc_number:
        // state.DatafetchCall.DataFetchDatass   .universal_acc_number,

        // ppo_number: state.DatafetchCall.DataFetchDatass.ppo_number,
        // scheme_number: state.DatafetchCall.DataFetchDatass.scheme_number,
      });
    }
  }, [
    state.DatafetchCall.DataFetchDatass,
    state.FormsIDList.DecalarationID,
    state.FormsIDList.ActiveTabs,
  ]);

  const GenderList = {
    Male: false,
    Female: false,
    other: false,
  };
  const [ForGender, SetGender] = useState(GenderList);
  useEffect(() => {
    if (
      state.FormsIDList.DecalarationID != "" &&
      state.DeclarationCall.Decalarationdatat != undefined &&
      state.DeclarationCall.Decalarationdatat.id != undefined &&
      state.DeclarationCall.Decalarationdatat.id != null &&
      state.FormsIDList.DecalarationID ==
      state.DeclarationCall.Decalarationdatat.id
    ) {
      // console.log(
      //   state.DeclarationCall.Decalarationdatat.gender.toLowerCase(),
      //   "gender"
      // );
      if (
        state.DeclarationCall.Decalarationdatat.gender.toLowerCase() == "male"
      ) {
        SetGender({
          ...ForGender,
          Male: true,
        });
      } else if (
        state.DeclarationCall.Decalarationdatat.gender.toLowerCase() == "female"
      ) {
        SetGender({
          ...ForGender,
          Female: true,
        });
      } else if (
        state.DeclarationCall.Decalarationdatat.gender.toLowerCase() == "others"
      ) {
        SetGender({
          ...ForGender,
          other: true,
        });
      }
    }
  }, [state.DeclarationCall.Decalarationdatat]);

  const preventTyping = (e) => {
    const invalidKey =
      (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) || // Any printable character
      e.key === " " || // Space key
      e.key === "Tab" || // Tab key
      e.key === "Enter"; // Enter key

    if (invalidKey) {
      e.preventDefault();
    }
  };

  const HandleNext = () => {
    var a = 0;

    if (
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
      state.EmployeeProfile.EmployeeProfileList.esi_form != undefined &&
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.EmployeeProfile.EmployeeProfileList.esi_form.id != undefined
    ) {
      dispatch(
        SetEsiFormIdActions(
          state.EmployeeProfile.EmployeeProfileList.esi_form.id,
        ),
      );
    }

    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item) => {
          try {
            const response = await fetch(item.url, {
              method: "PUT",
              headers: {
                "Content-Type": item.type,
                "x-amz-acl": "public-read",
              },
              body: item.putfiles,
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            if (state.FormsIDList.DecalarationID == "") {
              let datasendDelc = {
                employee_name: data.employee_name,
                spouse_name: data.spouse_name,
                // email:  data.email != "" && data.email != undefined && data.email.toLowerCase(),
                email: email,
                mobile_no: data.mobile_no,
                father_name: data.father_name,
                gender: GEDNDER,
                marital_status: data.marital_status.toLowerCase(),
                aadhar_number: data.aadhar_number,
                bank_acc_ifsc: data.bank_acc_ifsc,
                date_of_birth: data.date_of_birth,
                pan_number: data.pan_number,
                origin_country:
                  data.is_international == false || data.origin_country == ""
                    ? null
                    : data.origin_country,
                //  origin_country: data.origin_country,
                passport_number:
                  data.is_international == false || data.passport_number == ""
                    ? null
                    : data.passport_number,
                passport_validity_from:
                  data.is_international == false ||
                    data.passport_validity_from == ""
                    ? null
                    : data.passport_validity_from,
                passport_validity_to:
                  data.is_international == false ||
                    data.passport_validity_to == ""
                    ? null
                    : data.passport_validity_to,
                pf_acc_number: data.pf_acc_number,
                previous_end_date:
                  data.previous_end_date == "" ? null : data.previous_end_date,
                universal_acc_number: data.universal_acc_number,
                ppo_number: data.ppo_number,
                scheme_number: data.scheme_number,
                is_international:
                  data.is_international == "" ? false : data.is_international,
                // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
                // timeline_id: state.BasicFormCreated.BasciFormCreate,
                timeline_id:
                  state.BasicFormCreated.BasciFormCreate == ""
                    ? state.EmployeeProfile.EmployeeProfileList.id
                    : state.BasicFormCreated.BasciFormCreate,
                relation: data.relation,
                relation_name: data.relation_name,
                pension_schema: data.pension_schema,
                provident_fund_schema: data.provident_fund_schema,
                ifsc_code: data.ifsc_code,
                passport: presenturlInUrl.url,
                is_uan_number: data?.is_uan_number,
              };

              const payload = {
                data: datasendDelc,
                // data: formdatas,
              };
              dispatch(SetDeclarationcreateAction(payload));
              setPresentUrls([]);
              dispatch(setTheOnboardPhoneNumber(data.mobile_no));
            } else if (state.FormsIDList.DecalarationID != "") {
              let datasendDelc = {
                employee_name: data.employee_name,
                spouse_name: data.spouse_name,
                email: email,
                mobile_no: data.mobile_no,
                father_name: data.father_name,
                gender: GEDNDER,
                marital_status: data.marital_status.toLowerCase(),
                aadhar_number: data.aadhar_number,
                bank_acc_ifsc: data.bank_acc_ifsc,
                date_of_birth: data.date_of_birth,
                pan_number: data.pan_number,
                origin_country:
                  data.is_international == false || data.origin_country == ""
                    ? null
                    : data.origin_country,
                passport_number:
                  data.is_international == false ? "" : data.passport_number,
                passport_validity_from:
                  data.is_international == false ||
                    data.passport_validity_from == ""
                    ? null
                    : data.passport_validity_from,
                passport_validity_to:
                  data.is_international == false ||
                    data.passport_validity_to == ""
                    ? null
                    : data.passport_validity_to,
                pf_acc_number: data.pf_acc_number,
                previous_end_date:
                  data.previous_end_date == "" ? null : data.previous_end_date,
                universal_acc_number: data.universal_acc_number,
                ppo_number: data.ppo_number,
                scheme_number: data.scheme_number,
                is_international: data.is_international,
                // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
                // timeline_id: state.BasicFormCreated.BasciFormCreate,
                timeline_id:
                  state.BasicFormCreated.BasciFormCreate == ""
                    ? state.EmployeeProfile.EmployeeProfileList.id
                    : state.BasicFormCreated.BasciFormCreate,
                relation: data.relation,
                relation_name: data.relation_name,
                pension_schema: data.pension_schema,
                provident_fund_schema: data.provident_fund_schema,
                ifsc_code: data.ifsc_code,
                passport: presenturlInUrl.url,
                is_uan_number: data?.is_uan_number,
              };

              const payload = {
                data: datasendDelc,
                Retieveid: state.FormsIDList.DecalarationID,
                // timeline_id: state.BasicFormCreated.BasciFormCreate,
                timeline_id:
                  state.BasicFormCreated.BasciFormCreate == ""
                    ? state.EmployeeProfile.EmployeeProfileList.id
                    : state.BasicFormCreated.BasciFormCreate,
                // data: formdatas,
              };
              dispatch(SetDeclarationEditAction(payload));
              setPresentUrls([]);
              dispatch(setTheOnboardPhoneNumber(data.mobile_no));
            }

            setBankUplo(false);
            setPresentUrls([]);
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }),
      );
    };

    // console.log(data ,"2387823md");
    if (state.FormsIDList.DecalarationID == "") {
      // if(state.NumberCounts.Editable != 1 ){
      if (data.employee_name == "") {
        a = 1;
        setEmpNaErr("*Employee Name is required");
      }

      // if (data.spouse_name == "") {
      //   a = 1;
      //   spouseErr("*Spouse  Name is required");
      // }

      // if (data.email == "") {
      //   a = 1;
      //   setemalErr("*Email id is required");
      // }
      // if (!validator.isEmail(data.email)) {
      //   setemalErr("*Enter valid mail id");
      //   a = 1;
      // }

      if (data.mobile_no == "" || data.mobile_no == undefined) {
        a = 1;
        setMobilErr("*Mobile number is required");
      }
      if (
        data.mobile_no != undefined &&
        data.mobile_no != "" &&
        data.mobile_no.length > 10
      ) {
        a = 1;
        setMobilErr("*Mobile number should not more than 10 number");
      }
      if (
        data.mobile_no != undefined &&
        data.mobile_no != "" &&
        data.mobile_no.length < 10
      ) {
        a = 1;
        setMobilErr("*Mobile number should not less  than 10 number");
      }
      if (
        data.mobile_no != undefined &&
        data.mobile_no != "" &&
        data.mobile_no.length > 10
      ) {
        a = 1;
        setMobilErr("*Mobile number should not more than 10 number");
      }
      if (
        data.mobile_no != undefined &&
        data.mobile_no != "" &&
        data.mobile_no.length < 10
      ) {
        a = 1;
        setMobilErr("*Mobile number should not less  than 10 number");
      }

      if (data.relation == "") {
        a = 1;
        setFatherErr("*Family Member is required");
      }

      if (data.gender == "") {
        a = 1;
        setGrnderErr("*Gender  Name is required");
      }
      if (data.relation_name == "") {
        setNameErr("*Person Name is required");
        a = 1;
      }

      if (email != "" && !validator.isEmail(email)) {
        setemalErr("*Enter valid email id");
        a = 1;
      }

      // if (data.marital_status == "") {
      //   a = 1;
      //   setMatriErr("*Marital status is required");
      // }

      // if (data.aadhar_number == "") {
      //   a = 1;
      //   setAadhar("*Aadhar Number is required");
      // }

      // if (data.aadhar_number.length > 12) {
      //   a = 1;
      //   setAadhar("*Aadhar Number should not greater than 12 numbers");
      // }

      // if (data.aadhar_number.length < 12) {
      //   a = 1;
      //   setAadhar("*Aadhar Number  should not less than 12 numbers");
      // }

      // if (data.bank_acc_ifsc == "") {
      //   a = 1;
      //   setBankIfcEr("*Account Number or  Ifsc code  is required");
      // }

      if (data.date_of_birth == "") {
        a = 1;
        setDateErr("*Date of Birth is required");
      }
      // if (data.pan_number == "") {
      //   a = 1;
      //   setPAnNumErr("*Pan number is required");
      // }

      // if (data.is_international == "true") {
      //   if (data.origin_country == "") {
      //     a = 1;
      //     setOriginEr("*Origin country  is required");
      //   }

      //   if (data.passport_number == "") {
      //     a = 1;
      //     setPassNEr("*Passport Number  is required");
      //   }

      //   if (data.passport_validity_from == "") {
      //     a = 1;
      //     setpassPortVaERr("*Passport validity from  is required");
      //   }

      //   if (data.passport_validity_to == "") {
      //     a = 1;
      //     setpassPortVaERrT("*Passport validity to  is required");
      //   }
      // }

      // if (data.passport_number == "") {
      //   a = 1;
      //   setPassNEr("*Passport Number  is required");
      // }

      // if (data.passport_validity_from == "") {
      //   a = 1;
      //   setpassPortVaERr("*Passport validity from  is required");
      // }

      // if (data.passport_validity_to == "") {
      //   a = 1;
      //   setpassPortVaERrT("*Passport validity to  is required");
      // }

      // if (data.pf_acc_number == "") {
      //   a = 1;
      //   setPFerr("*Pf account Number  is required");
      // }

      // if (data.previous_end_date == "") {
      //   a = 1;
      //   setpreviouserr("*Previous end date  is required");
      // }
      // if (data.universal_acc_number == "") {
      //   a = 1;
      //   setUniversalerr("*Universal account Number  is required");
      // }
      if (isUanRequired && (!data.universal_acc_number || data.universal_acc_number == "")) {
        a = 1;
        setUniversalerr("*Universal Account Number  is required");
      }

      // if (data.ppo_number == "") {
      //   a = 1;
      //   setPPoErr("*Number  is required");
      // }

      // if (data.aadhar_number.length > 12) {
      //   a = 1;
      //   setAadhar("*Aadhar Number should not greater than 12 numbers");
      // }

      // if (data.aadhar_number.length == 12) {
      //   setAadhar("");
      // }

      // if (data.aadhar_number.length < 12) {
      //   a = 1;
      //   setAadhar("*Aadhar Number  should not less than 12 numbers");
      // }

      // if (data.scheme_number == "") {
      //   a = 1;
      //   setScheErr("*Scheme number  is required");
      // }

      // if (data.is_international == "") {
      //   a = 1;
      //   setInterNationErr("*Internation is required");
      // }

      // }
      if (BankImageCAnUplo == true && a == 0 && ErrorInde == 0) {
        fetchUploadFiles();
      }
      if (a == 0 && ErrorInde == 0 && BankImageCAnUplo == false) {
        let datasendDelc = {
          employee_name: data.employee_name,
          spouse_name: data.spouse_name,
          // email:  data.email != "" && data.email != undefined && data.email.toLowerCase(),
          email: email,
          mobile_no: data.mobile_no,
          father_name: data.father_name,
          gender: GEDNDER,
          marital_status: data.marital_status.toLowerCase(),
          aadhar_number: data.aadhar_number,
          bank_acc_ifsc: data.bank_acc_ifsc,
          date_of_birth: data.date_of_birth,
          pan_number: data.pan_number,
          origin_country:
            data.is_international == false || data.origin_country == ""
              ? null
              : data.origin_country,
          //  origin_country: data.origin_country,
          passport_number:
            data.is_international == false || data.passport_number == ""
              ? null
              : data.passport_number,
          passport_validity_from:
            data.is_international == false || data.passport_validity_from == ""
              ? null
              : data.passport_validity_from,
          passport_validity_to:
            data.is_international == false || data.passport_validity_to == ""
              ? null
              : data.passport_validity_to,
          pf_acc_number: data.pf_acc_number,
          previous_end_date:
            data.previous_end_date == "" ? null : data.previous_end_date,
          universal_acc_number: data.universal_acc_number,
          ppo_number: data.ppo_number,
          scheme_number: data.scheme_number,
          is_international:
            data.is_international == "" ? false : data.is_international,
          // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          relation: data.relation,
          relation_name: data.relation_name,
          pension_schema: data.pension_schema,
          provident_fund_schema: data.provident_fund_schema,
          ifsc_code: data.ifsc_code,
          passport: presenturlInUrl.url,
          is_uan_number: data?.is_uan_number,
        };
        formdatas.append("data", JSON.stringify(datasendDelc));
        if (BankImageCAnUplo) {
          formdatas.append("passport", file[0]);
        }

        const payload = {
          data: datasendDelc,
          // data: formdatas,
        };
        dispatch(SetDeclarationcreateAction(payload));
        setPresentUrls([]);
        dispatch(setTheOnboardPhoneNumber(data.mobile_no));
      }
    } else if (
      (state.FormsIDList.DecalarationID != "" &&
        data.employee_name !=
        state.DeclarationCall.Decalarationdatat.employee_name) ||
      data.spouse_name != state.DeclarationCall.Decalarationdatat.spouse_name ||
      data.mobile_no != state.DeclarationCall.Decalarationdatat.mobile_no ||
      email != state.DeclarationCall.Decalarationdatat.email ||
      data.father_name != state.DeclarationCall.Decalarationdatat.father_name ||
      data.gender != state.DeclarationCall.Decalarationdatat.gender ||
      data.marital_status !=
      state.DeclarationCall.Decalarationdatat.marital_status ||
      data.aadhar_number !=
      state.DeclarationCall.Decalarationdatat.aadhar_number ||
      data.bank_acc_ifsc !=
      state.DeclarationCall.Decalarationdatat.bank_acc_ifsc ||
      data.ifsc_code != state.DeclarationCall.Decalarationdatat.ifsc_code ||
      data.date_of_birth !=
      state.DeclarationCall.Decalarationdatat.date_of_birth ||
      data.pan_number != state.DeclarationCall.Decalarationdatat.pan_number ||
      // data.origin_country !=
      //   state.DeclarationCall.Decalarationdatat.origin_country ||
      data.passport_number !=
      state.DeclarationCall.Decalarationdatat.passport_number ||
      data.passport_validity_from !=
      state.DeclarationCall.Decalarationdatat.passport_validity_from ||
      data.passport_validity_to !=
      state.DeclarationCall.Decalarationdatat.passport_validity_to ||
      data.pf_acc_number !=
      state.DeclarationCall.Decalarationdatat.pf_acc_number ||
      // data.previous_end_date !=
      //   state.DeclarationCall.Decalarationdatat.previous_end_date ||
      data.universal_acc_number !=
      state.DeclarationCall.Decalarationdatat.universal_acc_number ||
      data.ppo_number != state.DeclarationCall.Decalarationdatat.ppo_number ||
      data.scheme_number !=
      state.DeclarationCall.Decalarationdatat.scheme_number ||
      data.relation_name !=
      state.DeclarationCall.Decalarationdatat.relation_name ||
      data.pension_schema !=
      state.DeclarationCall.Decalarationdatat.pension_schema ||
      data.provident_fund_schema !=
      state.DeclarationCall.Decalarationdatat.provident_fund_schema ||
      data.is_international !=
      state.DeclarationCall.Decalarationdatat.is_international ||
      presenturlInUrl.url !=
      state.DeclarationCall.Decalarationdatat.passport_id?.media_url
    ) {
      // if(state.NumberCounts.Editable != 1 ){
      if (data.employee_name == "") {
        a = 1;
        setEmpNaErr("*Employee Name is required");
      }

      // if (data.spouse_name == "") {
      //   a = 1;
      //   spouseErr("*Spouse  Name is required");
      // }

      // if (data.email == "") {
      //   a = 1;
      //   setemalErr("*Email id is required");
      // }
      // if (!validator.isEmail(data.email)) {
      //   setemalErr("*Enter valid mail id");
      //   a = 1;
      // }

      if (email != "" && !validator.isEmail(email)) {
        setemalErr("*Enter valid email id");
        a = 1;
      }
      if (data.relation_name == "") {
        setNameErr("*Person Name is required");
        a = 1;
      }

      if (data.mobile_no == "") {
        a = 1;
        setMobilErr("*Phone number is required");
      }
      if (data.mobile_no.length > 10) {
        a = 1;
        setMobilErr("*Phone number should not more than 10 number");
      }
      if (data.mobile_no.length < 10) {
        a = 1;
        setMobilErr("*Phone number should not less  than 10 number");
      }
      if (data.relation == "") {
        a = 1;
        setFatherErr("*Family Member is required");
      }

      // if (data.father_name == "") {
      //   a = 1;
      //   setFatherErr("*Father  Name is required");
      // }

      // if (data.gender == "") {
      //   a = 1;
      //   setGrnderErr("*Gender  Name is required");
      // }

      // if (data.marital_status == "") {
      //   a = 1;
      //   setMatriErr("*Marital status is required");
      // }

      // if (data.aadhar_number == "") {
      //   a = 1;
      //   setAadhar("*Aadhar Number is required");
      // }

      // if (data.bank_acc_ifsc == "") {
      //   a = 1;
      //   setBankIfcEr("*Account Number or  Ifsc code  is required");
      // }

      if (data.date_of_birth == "") {
        a = 1;
        setDateErr("*Date of Birth is required");
      }
      // if (data.pan_number == "") {
      //   a = 1;
      //   setPAnNumErr("*Pan number is required");
      // }
      // if (data.is_international == "true") {
      //   if (data.origin_country == "") {
      //     a = 1;
      //     setOriginEr("*Origin country  is required");
      //   }
      // }
      // if (data.passport_number == "") {
      //   a = 1;
      //   setPassNEr("*Passport Number  is required");
      // }

      // if (data.passport_validity_from == "") {
      //   a = 1;
      //   setpassPortVaERr("*Passport validity from  is required");
      // }

      // if (data.passport_validity_to == "") {
      //   a = 1;
      //   setpassPortVaERrT("*Passport validity to  is required");
      // }

      // if (data.pf_acc_number == "") {
      //   a = 1;
      //   setPFerr("*Pf account Number  is required");
      // }

      // if (data.previous_end_date == "") {
      //   a = 1;
      //   setpreviouserr("*Previous end date  is required");
      // }
      if (isUanRequired && (!data.universal_acc_number || data.universal_acc_number == "")) {
        a = 1;
        setUniversalerr("*Universal Account Number  is required");
      }

      // if (data.ppo_number == "") {
      //   a = 1;
      //   setPPoErr("*Number  is required");
      // }

      // if (data.scheme_number == "") {
      //   a = 1;
      //   setScheErr("*Scheme number  is required");
      // }

      // if (data.is_international == "") {
      //   a = 1;
      //   setInterNationErr("*Internation is required");
      // }

      // }

      if (BankImageCAnUplo == true && a == 0 && ErrorInde == 0) {
        fetchUploadFiles();
      }
      if (a == 0 && ErrorInde == 0 && BankImageCAnUplo == false) {
        let datasendDelc = {
          employee_name: data.employee_name,
          spouse_name: data.spouse_name,
          // email: data.email,
          email: email,
          mobile_no: data.mobile_no,
          father_name: data.father_name,
          // gender: data.gender,
          gender: GEDNDER,
          marital_status: data.marital_status.toLowerCase(),
          aadhar_number: data.aadhar_number,
          bank_acc_ifsc: data.bank_acc_ifsc,
          date_of_birth: data.date_of_birth,
          pan_number: data.pan_number,
          origin_country:
            data.is_international == false || data.origin_country == ""
              ? null
              : data.origin_country,
          passport_number:
            data.is_international == false ? "" : data.passport_number,
          passport_validity_from:
            data.is_international == false || data.passport_validity_from == ""
              ? null
              : data.passport_validity_from,
          passport_validity_to:
            data.is_international == false || data.passport_validity_to == ""
              ? null
              : data.passport_validity_to,
          pf_acc_number: data.pf_acc_number,
          previous_end_date:
            data.previous_end_date == "" ? null : data.previous_end_date,
          universal_acc_number: data.universal_acc_number,
          ppo_number: data.ppo_number,
          scheme_number: data.scheme_number,
          is_international: data.is_international,
          // timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          relation: data.relation,
          relation_name: data.relation_name,
          pension_schema: data.pension_schema,
          provident_fund_schema: data.provident_fund_schema,
          ifsc_code: data.ifsc_code,
          passport: presenturlInUrl.url,
          is_uan_number: data?.is_uan_number,
        };

        const payload = {
          data: datasendDelc,
          Retieveid: state.FormsIDList.DecalarationID,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          // data: formdatas,
        };
        dispatch(SetDeclarationEditAction(payload));
        setPresentUrls([]);
        dispatch(setTheOnboardPhoneNumber(data.mobile_no));
      }
    } else if (
      state.FormsIDList.DecalarationID != "" &&
      data.employee_name ==
      state.DeclarationCall.Decalarationdatat.employee_name &&
      data.spouse_name == state.DeclarationCall.Decalarationdatat.spouse_name &&
      data.mobile_no == state.DeclarationCall.Decalarationdatat.mobile_no &&
      data.email == state.DeclarationCall.Decalarationdatat.email &&
      data.father_name == state.DeclarationCall.Decalarationdatat.father_name &&
      data.gender == state.DeclarationCall.Decalarationdatat.gender &&
      data.marital_status ==
      state.DeclarationCall.Decalarationdatat.marital_status &&
      data.aadhar_number ==
      state.DeclarationCall.Decalarationdatat.aadhar_number &&
      data.bank_acc_ifsc ==
      state.DeclarationCall.Decalarationdatat.bank_acc_ifsc &&
      data.ifsc_code == state.DeclarationCall.Decalarationdatat.ifsc_code &&
      data.date_of_birth ==
      state.DeclarationCall.Decalarationdatat.date_of_birth &&
      data.pan_number == state.DeclarationCall.Decalarationdatat.pan_number &&
      // data.origin_country ==
      //   state.DeclarationCall.Decalarationdatat.origin_country &&
      data.passport_number ==
      state.DeclarationCall.Decalarationdatat.passport_number &&
      data.passport_validity_from ==
      state.DeclarationCall.Decalarationdatat.passport_validity_from &&
      data.passport_validity_to ==
      state.DeclarationCall.Decalarationdatat.passport_validity_to &&
      data.pf_acc_number ==
      state.DeclarationCall.Decalarationdatat.pf_acc_number &&
      data.previous_end_date ==
      state.DeclarationCall.Decalarationdatat.previous_end_date &&
      data.universal_acc_number ==
      state.DeclarationCall.Decalarationdatat.universal_acc_number &&
      data.ppo_number == state.DeclarationCall.Decalarationdatat.ppo_number &&
      data.scheme_number ==
      state.DeclarationCall.Decalarationdatat.scheme_number &&
      data.pension_schema ==
      state.DeclarationCall.Decalarationdatat.pension_schema &&
      data.provident_fund_schema ==
      state.DeclarationCall.Decalarationdatat.provident_fund_schema &&
      data.is_international ==
      state.DeclarationCall.Decalarationdatat.is_international
    ) {
      dispatch(SetActiveTabs(9));
    }
  };

  return (
    <>
      <div>
        <div>
          <div className=" BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          <span>Declaration Form</span>
                        </div>
                      </div>

                      <div className="Modal-Body ModalForms">
                        <div className="row">
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Name of Member
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              name="employee_name"
                              autocomplete="off"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3 &&
                                  state.DatafetchCall.DataFetchDatass !=
                                  undefined &&
                                  (state.DatafetchCall.DataFetchDatass
                                    .first_name !=
                                    "") ==
                                  1
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                // HandleChanges(e);
                                // setEmpNaErr("");

                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                  setEmpNaErr("");
                                  setErrInde(0);
                                } else {
                                  setErrInde(1);
                                  setEmpNaErr(
                                    "Name  should not exit  more than the 150 characters",
                                  );
                                }
                              }}
                              value={data.employee_name}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {empNameerr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3 ">
                            <label
                              for="validationCustom01"
                              class="form-label"
                              style={{ width: "100%" }}
                            >
                              Select Family Member
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            {/* <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="father_name"
                              value={data.father_name}
                              readOnly={
                                state.NumberCounts.Editable == 1 ? true : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setFatherErr("");
                              }}
                            /> */}
                            <Select
                              options={
                                FamilyOptions != null
                                  ? FamilyOptions
                                  : { value: "Search", label: "Search" }
                              }
                              onChange={(e) => {
                                //handleChange(e)
                                setData({
                                  ...data,
                                  relation: e.value.toLowerCase(),
                                });
                                HandleAddingChanges(e);
                                setFatherErr("");
                                handleAddFields(e);
                                setDisplay(true);
                              }}
                              isDisabled={
                                (state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3) ||
                                  (selectedfamRe != null &&
                                    inputFields.length != 0)
                                  ? true
                                  : false
                              }
                              className="form-label"
                              value={selectedfamRe}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {FatherErr}
                            </p>
                          </div>

                          {display &&
                            inputFields.map((inputField, index) => {
                              return (
                                <>
                                  {index === 0 ? (
                                    <Fragment key={`${inputField}~${index}`}>
                                      {/* <div className=" col-6 text-right">
                                        <div
                                          className=" btn btn-link StatusList"
                                          disabled={index === 0}
                                          onClick={() =>
                                            handleRemoveFields(index)
                                          }
                                        >
                                          <div className="DeclineStatus">
                                            <span>x</span>
                                          </div>
                                        </div>
                                      </div> */}
                                      {/* <div className="col-sm-3">
                                        <h5>
                                          {inputField.person_type !=
                                            undefined &&
                                            capitalizeFirstLetter(
                                              inputField.person_type
                                            )}
                                        {inputField.person_type} 
                                        </h5>
                                      </div> */}

                                      <div className=" col-sm-3 mt-2">
                                        <label
                                          htmlFor="firstName"
                                          className="form-label Declarationfromlabe"
                                        >
                                          <span>
                                            Person Name
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </span>
                                          {state.NumberCounts.Editable == 1 &&
                                            state.NumberCounts.EmployeeFormFIll ==
                                            true &&
                                            state.ClientBranchIDs.SUBROLE == 3 ? (
                                            <div
                                              className=" btn btn-link StatusList"
                                              onClick={() =>
                                                handleRemoveFields(index)
                                              }
                                            >
                                              <div className="DeclineStatus">
                                                <span>x</span>
                                              </div>
                                            </div>
                                          ) : (
                                            state.NumberCounts.Editable == 2 &&
                                            state.NumberCounts
                                              .EmployeeFormFIll == true && (
                                              <div
                                                className=" btn btn-link StatusList"
                                                onClick={() =>
                                                  handleRemoveFields(index)
                                                }
                                              >
                                                <div className="DeclineStatus">
                                                  <span>x</span>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="firstName"
                                          name="person_name"
                                          value={inputField.person_name || ""}
                                          onChange={(event) => {
                                            handleInputChange(index, event);
                                            setNameErr("");
                                          }}
                                          disabled={
                                            state.NumberCounts.Editable == 1 &&
                                              state.ClientBranchIDs.SUBROLE != 3
                                              ? true
                                              : false
                                          }
                                          autoComplete="off"
                                        />
                                        <p
                                          className="Error"
                                          style={{ paddingLeft: "12px" }}
                                        >
                                          {NameErr}
                                        </p>
                                      </div>
                                    </Fragment>
                                  ) : null}
                                </>
                              );
                            })}
                          {/* {organization?.organization?.id !==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (

                              <div className="col-sm-3 mt-3">
                                <label for="validationCustom01" class="form-label">
                                  Date of Birth
                                </label>
                                <input
                                  type="date"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="date_of_birth"
                                  value={data.date_of_birth}
                                  readOnly={
                                    // state.NumberCounts.Editable == 1 &&
                                    // state.ClientBranchIDs.SUBROLE != 3 &&
                                    // state.DatafetchCall.DataFetchDatass !=
                                    //   undefined &&
                                    // (state.DatafetchCall.DataFetchDatass
                                    //   .date_of_birth !=
                                    //   "") ==
                                    //   1
                                    //   ? true
                                    //   : false
                                    // state.NumberCounts.Editable == 1 &&
                                    // state.ClientBranchIDs.SUBROLE != 3
                                    //  &&
                                    // state.DatafetchCall.DataFetchDatass !=
                                    //   undefined &&
                                    // (state.DatafetchCall.DataFetchDatass
                                    //   .date_of_birth !=
                                    //   "") ==
                                    //   1
                                    //   ? true
                                    //   : false

                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  // readOnly={
                                  //   (state.NumberCounts.Editable == 1 && state.ClientBranchIDs.SUBROLE != 3) ||
                                  //   (state.DatafetchCall.DataFetchDatass != undefined &&
                                  //     (state.DatafetchCall.DataFetchDatass.date_of_birth != "") == 1)
                                  //     ? true
                                  //     : false
                                  // }

                                  onKeyDown={preventTyping}
                                  onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setDateErr("");
                                  }}
                                  min="1955-01-01"
                                  max="2004-12-01"
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>
                                  {DateERr}
                                </p>
                              </div>)}
                          {organization?.organization?.id !==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (

                              <div className="col-sm-3 mt-3">
                                <label for="validationCustom01" class="form-label">
                                  Gender
                                </label>

                                <div className="col">
                                  <div
                                    class="form-check d-inline"
                                    style={{ marginRight: "13px" }}
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value="Male"
                                      id="flexCheckDefault"
                                      name="gender"
                                      checked={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? ForGender.Male
                                          : data.gender == "Male" ||
                                            data.gender == "MALE"
                                            ? true
                                            : false
                                      }
                                      readOnly={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3 &&
                                          state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .gender != ""
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setGrnderErr("");
                                      }}
                                      disabled={
                                        (state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE == 2) ||
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                    />
                                    <label class="form-check-label">Male</label>
                                  </div>
                                  <div
                                    class="form-check d-inline"
                                    style={{ marginRight: "13px" }}
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value="Female"
                                      id="flexCheckChecked"
                                      name="gender"
                                      checked={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? ForGender.Female
                                          : data.gender == "Female" ||
                                            data.gender == "FEMALE"
                                            ? true
                                            : false
                                      }
                                      readOnly={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3 &&
                                          state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .gender != ""
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setGrnderErr("");
                                      }}
                                      disabled={
                                        (state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE == 2) ||
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                    />
                                    <label
                                      class="form-check-label"
                                      for="flexCheckChecked"
                                    >
                                      Female
                                    </label>
                                  </div>
                                  <div
                                    class="form-check  d-inline "
                                    style={{ marginRight: "13px" }}
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value="Others"
                                      name="gender"
                                      id="flexCheckChecked"
                                      checked={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? ForGender.other
                                          : data.gender == "Others" ||
                                            data.gender == "OTHERS"
                                            ? true
                                            : false
                                      }
                                      readOnly={
                                        state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE != 3 &&
                                          state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .gender != ""
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setGrnderErr("");
                                      }}
                                      disabled={
                                        (state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE == 2) ||
                                          state.ClientBranchIDs.SUBROLE != 3
                                          ? true
                                          : false
                                      }
                                    />
                                    <label
                                      class="form-check-label"
                                      for="flexCheckChecked"
                                    >
                                      other
                                    </label>

                                    <p
                                      className="Error"
                                      style={{ marginLeft: "-5px" }}
                                    >
                                      {genderErr}
                                    </p>
                                  </div>
                                </div>
                              </div>)} */}
                          {/* ------------------------make ---as----drop----downs----------------------------- */}
                          {/* <div className="col mt-3">
                            <label for="validationCustom01" class="form-label">
                              Marital Status
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="marital_status"
                              value={data.marital_status}
                              readOnly={
                                state.NumberCounts.Editable == 1 ? true : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setMatriErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {maritalStErr}
                            </p>
                          </div> */}

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Marital Status
                            </label>

                            {/* <select
                              style={{ width: "100%", padding: "10px" }}
                              class="form-select form-select-lg mb-3"
                              aria-label=".form-select-lg example"
                              name="marital_status"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setMatriErr("");
                              }}
                            >
                              {Options.map((item) => (
                                <option
                                  value={item.value}
                                  selected={
                                    data.marital_status != undefined
                                      ? data.marital_status.toLowerCase() ==
                                        item.value.toLowerCase()
                                      : null
                                  }
                                >
                                  {item.value}
                                </option>
                              ))}
                            </select> */}

                            <Select
                              class="form-control "
                              name="marital_status"
                              // isDisabled={
                              //   state.NumberCounts.Editable == 1 &&
                              //   state.ClientBranchIDs.SUBROLE != 3
                              //     ? true
                              //     : false
                              // }
                              onChange={(e) => {
                                // HandleChanges(e);
                                setMaritalStatus(e);
                                setData({
                                  ...data,
                                  marital_status: e.value,
                                });

                                setMatriErr("");
                              }}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              isDisabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              options={Options}
                              value={MaterilStatus}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {maritalStErr}
                            </p>
                          </div>
                          {/* {organization?.organization?.id !==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (

                              <div className="col-sm-3 mt-3">
                                <label for="validationCustom01" class="form-label">
                                  Email
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="email"
                                  value={data.email}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3 &&
                                      state.DatafetchCall.DataFetchDatass !=
                                      undefined &&
                                      state.DatafetchCall.DataFetchDatass.email_id
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setemalErr("");
                                    setemail(e.target.value);
                                  }}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>
                                  {emailERr}
                                </p>
                              </div>)}

                     
                          {organization?.organization?.id !==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (

                              <div className="col-sm-3 mt-3">
                                <label for="validationCustom01" class="form-label">
                                  Mobile No
                                </label>
                                <input
                                  // type="number"
                                  // onKeyDown={(evt) =>
                                  //   ["e", "E", "+", "-"].includes(evt.key) &&
                                  //   evt.preventDefault()
                                  // }
                                  step="1"
                                  type={shouldMask ? "text" : "number"}
                                  onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                                  onPaste={handlePaste} // Handle pasting
                                  onWheel={preventZoom} // Prevent zooming with the mouse wheel
                                  ref={inputRef}
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="mobile_no"
                                  value={
                                    shouldMask && data.mobile_no
                                      ? `******${String(data.mobile_no).slice(-4)}`
                                      : data.mobile_no
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3 &&
                                      state.DatafetchCall.DataFetchDatass !=
                                      undefined &&
                                      state.DatafetchCall.DataFetchDatass
                                        .phone_number != ""
                                      ? true
                                      : false
                                  }
                                  // onChange={(e) => {
                                  //   HandleChanges(e);
                                  //   // setMobilErr("");

                                  //   const value = e.target.value.length;

                                  //   if (value > 10) {
                                  //     setMobilErr(
                                  //       "*Mobile Number should not exceed 10 digits."
                                  //     );
                                  //     setErrInde(1);
                                  //   } else {
                                  //     setMobilErr("");
                                  //     setErrInde(0);
                                  //   }
                                  // }}

                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Regular expression to validate phone number
                                    const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                    setMobilErr("");
                                    // Check if value exceeds 10 digits or is invalid
                                    if (
                                      value.length <= 10 &&
                                      (phoneRegex.test(value) || value === "")
                                    ) {
                                      HandleChanges(e);
                                    }
                                  }}
                                />
                                <p className="Error" style={{ marginLeft: "-5px" }}>
                                  {mobileNumErr}
                                </p>
                              </div>)} */}


                          {/* <div className="col-sm-3 mt-3">
  <label className="form-label">
    UAN Declaration
  </label>
  <div>
    <div className="form-check form-check-inline Checkboxfields">
      <input
        className="form-check-input"
        type="checkbox"
        id="uanYes"
        checked={data.is_uan_number === true}
        onChange={(e) =>
          setData((prev) => ({
            ...prev,
            is_uan_number: e.target.checked ? true : null, // null if unchecked
          }))
        }
        readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3 
                                                            ? true
                                  : false
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3 
                                                            ? true
                                  : false
                              }
      />
      <label className="form-check-label" htmlFor="uanYes">Yes</label>
    </div>
    <div className="form-check form-check-inline Checkboxfields">
      <input
        className="form-check-input"
        type="checkbox"
        id="uanNo"
        checked={data.is_uan_number === false}
        onChange={(e) =>
          setData((prev) => ({
            ...prev,
            is_uan_number: e.target.checked ? false : null, // null if unchecked
          }))
        }
        disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3 
                                                            ? true
                                  : false
                              }
             readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3 
                                                            ? true
                                  : false
                              }
      />
      <label className="form-check-label" htmlFor="uanNo">No</label>
    </div>
  </div>
</div> */}

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Universal Account Number
                            </label>
                            {isUanRequired && <span style={{ color: "red" }}>*</span>}
                            <input
                              type="number"
                              // onKeyDown={(evt) =>
                              //   ["e", "E", "+", "-"].includes(evt.key) &&
                              //   evt.preventDefault()
                              // }
                              step="1"
                              onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                              onPaste={handlePaste} // Handle pasting
                              onWheel={preventZoom} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="universal_acc_number"
                              value={data.universal_acc_number}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                const value = e.target.value;

                                if (value.length <= 12) {
                                  HandleChanges(e);
                                  setUniversalerr("");
                                }
                              }}
                            />
                            {console.log(data, "dalksdklaklsdka")}
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {universalErr}
                            </p>
                          </div>
                          {/* </div>

                        <div className="row"> */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Previous PF Account Number
                            </label>
                            <input
                              type="number"
                              // onKeyDown={(evt) =>
                              //   ["e", "E", "+", "-"].includes(evt.key) &&
                              //   evt.preventDefault()
                              // }
                              step="1"
                              onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                              onPaste={handlePaste} // Handle pasting
                              onWheel={preventZoom} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="pf_acc_number"
                              value={data.pf_acc_number}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setpreviouserr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {previouerr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Date of Exit From Previous Employment
                            </label>
                            <input
                              type="date"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="previous_end_date"
                              value={data.previous_end_date}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setpreviouserr("");
                              }}
                              onKeyDown={preventTyping}
                              onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {previouerr}
                            </p>
                          </div>
                          {/* </div>

                        <div className="row"> */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Scheme Certificate Number
                            </label>
                            <input
                              type="number"
                              // onKeyDown={(evt) =>
                              //   ["e", "E", "+", "-"].includes(evt.key) &&
                              //   evt.preventDefault()
                              // }
                              step="1"
                              onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                              onPaste={handlePaste} // Handle pasting
                              onWheel={preventZoom} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="scheme_number"
                              value={data.scheme_number}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setScheErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {schemeErr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Pension Payment Order
                            </label>
                            <input
                              type="number"
                              // onKeyDown={(evt) =>
                              //   ["e", "E", "+", "-"].includes(evt.key) &&
                              //   evt.preventDefault()
                              // }
                              step="1"
                              onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                              onPaste={handlePaste} // Handle pasting
                              onWheel={preventZoom} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="ppo_number"
                              value={data.ppo_number}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                setPPoErr("");
                                HandleChanges(e);
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {PPOErr}
                            </p>
                          </div>
                          {/* </div> */}
                          {/* {state.NumberCounts.Editable == 1 &&
                        state.ClientBranchIDs.SUBROLE != 3 &&
                        state.DeclarationCall.Decalarationdatat
                          .is_international ? (
                          <div className="row">
                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                International Workers weqwe
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="origin_country"
                                // value={data.origin_country}
                                value={data.origin_country}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setOriginEr("");
                                }}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {origonErr}
                              </p>
                            </div>
                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                International Workers , If yes, State country of
                                origin
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="origin_country"
                                value={data.origin_country}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setOriginEr("");
                                }}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {origonErr}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <>
                            {state.NumberCounts.Editable == 1 &&
                            state.ClientBranchIDs.SUBROLE != 3 ? (
                              <div className="row">
                                <div
                                  className="col mt-3"
                                  style={{ paddingLeft: "40px" }}
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    readOnly
                                    value="other"
                                    id="flexCheckChecked"
                                    checked
                                  />
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Not a international worker
                                  </label>
                                </div>
                              </div>
                            ) : null}
                          </>
                        )} */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Whether Earlier a member of Employee , Provident
                              Fund
                            </label>

                            <div className="col">
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="true"
                                  id="flexCheckDefault"
                                  name="provident_fund_schema"
                                  checked={
                                    // state.NumberCounts.Editable == 1
                                    //   ? ForGender.Male
                                    data.provident_fund_schema == true
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    // HandleChanges(e, true);
                                    setInterNationErr("");
                                    const { name } = e.target;
                                    const checked = e.target.checked; // Boolean value of checkbox state
                                    setData({
                                      ...data,
                                      [name]: checked, // Update state with boolean value
                                    });
                                  }}
                                />
                                <label class="form-check-label">Yes</label>
                              </div>
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="false"
                                  id="flexCheckChecked"
                                  name="provident_fund_schema"
                                  checked={
                                    data.provident_fund_schema == false
                                      ? true
                                      : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    // HandleChanges(e, false);
                                    // setInterNationErr("");
                                    const { name } = e.target;
                                    const checked = e.target.checked; // Boolean value of checkbox state
                                    setData({
                                      ...data,
                                      [name]: false, // Update state with boolean value
                                    });
                                  }}
                                />

                                <label class="form-check-label">No</label>

                                {/* <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {isinternationErr}
                                  </p> */}
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Whether Earlier a member of Employee , Provident
                              Fund Scheme 1995
                            </label>

                            <div className="col">
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="true"
                                  id="flexCheckDefault"
                                  name="pension_schema"
                                  checked={
                                    // state.NumberCounts.Editable == 1
                                    //   ? ForGender.Male
                                    data.pension_schema == true ? true : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    // HandleChanges(e, true);
                                    const { name } = e.target;
                                    const checked = e.target.checked; // Boolean value of checkbox state
                                    setData({
                                      ...data,
                                      [name]: true, // Update state with boolean value
                                    });

                                    // setInterNationErr("");
                                  }}
                                />
                                <label class="form-check-label">Yes</label>
                              </div>
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="false"
                                  id="flexCheckChecked"
                                  name="pension_schema"
                                  checked={
                                    data.pension_schema == false ? true : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    // HandleChanges(e, false);
                                    const { name } = e.target;
                                    const checked = e.target.checked; // Boolean value of checkbox state
                                    setData({
                                      ...data,
                                      [name]: false, // Update state with boolean value
                                    });

                                    setInterNationErr("");
                                  }}
                                />

                                <label class="form-check-label">No</label>

                                {/* <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {isinternationErr}
                                  </p> */}
                              </div>
                            </div>
                          </div>
                          {/* {
                        // state.NumberCounts.Editable == 2 ||
                        state.ClientBranchIDs.SUBROLE == 3 ? ( */}
                          {/* <div className="row"> */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              International Workers
                            </label>

                            <div className="col">
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="true"
                                  id="flexCheckDefault"
                                  name="is_international"
                                  checked={
                                    // state.NumberCounts.Editable == 1
                                    //   ? ForGender.Male
                                    data.is_international == true ? true : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e, true);
                                    setInterNationErr("");
                                  }}
                                />
                                <label class="form-check-label">Yes</label>
                              </div>
                              {/* {data.is_international} */}
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="false"
                                  id="flexCheckChecked"
                                  name="is_international"
                                  checked={
                                    data.is_international == false
                                      ? true
                                      : false
                                  }
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e, false);
                                    setInterNationErr("");
                                    // setData({
                                    //   ...data,
                                    //   origin_country:"",
                                    //   passport_validity_from:  null  ,
                                    //   passport_number: "",
                                    //   passport_validity_to: null,
                                    // });
                                  }}
                                />

                                <label class="form-check-label">No</label>

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {isinternationErr}
                                </p>
                              </div>
                            </div>
                          </div>
                          {data.is_international == true ? (
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                International Workers , If yes, State country of
                                origin
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                disabled={data.is_international == "false"}
                                autocomplete="off"
                                name="origin_country"
                                value={data.origin_country}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setOriginEr("");
                                }}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {origonErr}
                              </p>
                            </div>
                          ) : null}
                          {/* </div> */}
                          {/* // ) : null} */}
                          {data.is_international == true ? (
                            <>
                              <div className="col-sm-3 mt-3">
                                <label class="form-label">
                                  Passport Number
                                  <br />
                                  <br />
                                </label>
                                <input
                                  type="number"
                                  // onKeyDown={(evt) =>
                                  //   ["e", "E", "+", "-"].includes(evt.key) &&
                                  //   evt.preventDefault()
                                  // }
                                  step="1"
                                  onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                                  onPaste={handlePaste} // Handle pasting
                                  onWheel={preventZoom} // Prevent zooming with the mouse wheel
                                  ref={inputRef}
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="passport_number"
                                  value={data.passport_number}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setPassNEr("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {passportNerr}
                                </p>
                              </div>
                              <div
                                className="row"
                                style={{
                                  padding: "0px 10px",
                                  marginTop: "-21px",
                                }}
                              >
                                <div
                                  className="col-12"
                                  style={{ marginTop: "12px" }}
                                >
                                  <label
                                    className="form-label"
                                    style={{ padding: "10px 10px" }}
                                  >
                                    Validity of passport
                                  </label>
                                </div>
                                <div
                                  className="col "
                                  style={{ paddingLeft: "25px" }}
                                >
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    from
                                  </label>
                                  <input
                                    type="date"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="passport_validity_from"
                                    value={data.passport_validity_from}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      HandleChanges(e);
                                      setpassPortVaERr("");
                                    }}
                                    onKeyDown={preventTyping}
                                    onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                                  />
                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {passportValidERr}
                                  </p>
                                </div>

                                <div className="col ">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    To
                                  </label>
                                  <input
                                    type="date"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="passport_validity_to"
                                    value={data.passport_validity_to}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      HandleChanges(e);
                                      setpassPortVaERrT("");
                                    }}
                                    onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                                    onKeyDown={preventTyping}
                                  />
                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {passportValidERrT}
                                  </p>
                                </div>
                              </div>
                            </>
                          ) : null}
                          {/* {organization?.organization?.id !==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                              <>

                                <div className="col-sm-3 mt-3">
                                  <label for="validationCustom01" class="form-label">
                                    Bank Account No
                                    <br />
                                    <br />
                                  </label>
                                  <input
                                    type={shouldMask ? "text" : "number"}
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="bank_acc_ifsc"
                                    step="1"
                                    onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                                    onPaste={handlePaste} // Handle pasting
                                    onWheel={preventZoom} // Prevent zooming with the mouse wheel
                                    ref={inputRef}
                                    value={
                                      shouldMask && data.bank_acc_ifsc
                                        ? `**** **** ${String(data.bank_acc_ifsc).slice(-4)}`
                                        : data.bank_acc_ifsc
                                    }
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .account_number
                                          ? state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE == 3
                                          : false
                                    }
                                    onChange={(e) => {
                                      // HandleChanges(e);
                                      // setBankIfcEr("");
                                      const inputValue = e.target.value;
                                      // if (inputValue <= 0) {
                                      //   setBankIfcEr("*Account number must be greater than 0.");
                                      //   setErrInde(1);
                                      //   e.target.value = "";
                                      // }
                                      if (inputValue.length > 100) {
                                        setBankIfcEr(
                                          "*Account number must not exceed 100 digits.",
                                        );
                                        setErrInde(1);
                                      } else if (inputValue.length <= 7) {
                                        setBankIfcEr(
                                          "*Account number must be at least 8 digits.",
                                        );
                                        setErrInde(1);
                                      } else {
                                        setBankIfcEr("");
                                        setErrInde(0);
                                      }
                                      HandleChanges(e);
                                      // }}
                                    }}
                                  />
                                  <p className="Error" style={{ marginLeft: "-5px" }}>
                                    {Bacnk_IFErr}
                                  </p>
                                </div>

                                <div className="col-sm-3 mt-3">
                                  <label for="validationCustom01" class="form-label">
                                    IFSC Code
                                    <br />
                                    <br />
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="ifsc_code"
                                    value={data.ifsc_code}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .ifsc_code
                                          ? state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE == 3
                                          : false
                                    }
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      if (inputValue.length > 30) {
                                        e.preventDefault();
                                        setIfsErr(
                                          "*IFSC code must not exceed 30 characters.",
                                        );
                                        setErrInde(1);
                                      } else {
                                        setIfsErr("");
                                        setErrInde(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                  />
                                  <p className="Error" style={{ marginLeft: "-5px" }}>
                                    {IFSErr}
                                  </p>
                                </div>

                                <div className="col-sm-3 mt-3">
                                  <label for="validationCustom01" class="form-label">
                                    Aadhaar Number
                                    <br />
                                    <br />
                                  </label>
                                  <input
                                    type="text"
                                    step="1"
                                    onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                                    onPaste={handlePaste} // Handle pasting
                                    onWheel={preventZoom} // Prevent zooming with the mouse wheel
                                    ref={inputRef}
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="aadhar_number"
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .aadhar_number
                                          ? state.NumberCounts.Editable == 1 &&
                                          state.ClientBranchIDs.SUBROLE == 3
                                          : false
                                    }
                                    onChange={(e) => {
                                      // HandleChanges(e);
                                      // setAadhar("");

                                      // const value = e.target.value
                                      // .replace(/[^\w\s]/gi, "")
                                      // .slice(0, 20);
                                      const value = e.target.value;
                                      const phoneRegex = /^[1-9][0-9]{0,11}$/; // Adjusted regex to match up to 12 digits
                                      setAadhar("");

                                      if (
                                        value.length <= 12 &&
                                        (phoneRegex.test(value) || value === "")
                                      ) {
                                        HandleChanges(e);
                                      }

                                      // if (value > 12) {
                                      //   setAadhar(
                                      //     "*Aadhar Number should not exceed 12 digits."
                                      //   );
                                      //   setErrInde(1);
                                      // } else {
                                      //   setAadhar("");
                                      //   setErrInde(0);
                                      // }
                                    }}
                                    // value={data.aadhar_number}
                                    value={
                                      data.aadhar_number
                                        ? shouldMask
                                          ? `**** **** ${data.aadhar_number.toString().slice(-4)}`
                                          : data.aadhar_number
                                        : ""
                                    }
                                  />
                                  <p className="Error" style={{ marginLeft: "-5px" }}>
                                    {AAdErr}
                                  </p>
                                </div>

                                <div className="col-sm-3 mt-3">
                                  <label for="validationCustom01" class="form-label ">
                                    Permanent Account Number (PAN), if available
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="pan_number"
                                    value={
                                      shouldMask && data.pan_number
                                        ? `******${String(data.pan_number).slice(-4)}`
                                        : data.pan_number
                                    }
                                    id="validationCustom01"
                                    autoComplete="off"
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.DatafetchCall.DataFetchDatass !=
                                          undefined &&
                                          state.DatafetchCall.DataFetchDatass
                                            .pan_number
                                          ? !(
                                            state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          )
                                          : false
                                    }
                                    // readOnly
                                    onChange={(e) => {
                                      if (e.target.value.length < 21) {
                                        HandleChanges(e);
                                        setPAnNumErr("");
                                      } else {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                  <p className="Error" style={{ marginLeft: "-5px" }}>
                                    {panNmErr}
                                  </p>
                                </div>
                              </>)} */}

                          {/* <div className="col mt-3">
                            <label for="validationCustom01" class="form-label">
                              Name of Member
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              name="spouse_name"
                              autocomplete="off"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                spouseErr("");
                              }}
                              value={data.spouse_name}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {spouseNaErr}
                            </p>
                          </div> */}
                        </div>
                        <div className="col-6 mt-3">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ width: "100%" }}
                          >
                            Passport Image
                            <small style={{ color: "red", marginLeft: "12px" }}>
                              Note:Upload the picture, please. Verify that the
                              file is in the JPG, JPEG, or PNG format and that
                              its size is less than 10 MB.
                            </small>
                          </label>

                          {url ||
                            (url != null &&
                              state.ClientBranchIDs.SUBROLE != 3) ? (
                            <img
                              src={url}
                              onClick={(e) => {
                                if (state.NumberCounts.Editable == 1) {
                                  window.open(url);
                                }
                              }}
                              className="pointer"
                              style={{
                                // height: 115,
                                // width: 115,
                                // marginRight: 25,
                                // borderRadius: "50%",
                                height: "153px",
                                width: "198px",
                                margin: "25px",
                                border: "1px solid #000",
                                marginRight: "25",
                              }}
                              alt="Image"
                            />
                          ) : null}

                          {!url ? (
                            //||
                            // && state.NumberCounts.Editable != 1
                            // ||
                            // state.ClientBranchIDs.SUBROLE != 3

                            <Button
                              className="btn doctorupload"
                              variant="contained"
                              component="label"
                              style={{
                                background: "#ef4d39",
                                color: "#fff",
                                fontSize: "11px !important",
                              }}
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                            >
                              <input
                                type="file"
                                hidden
                                accept="image/png, image/jpeg"
                                onChange={(e) => handleFiles(e)}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                ref={fileInputRef}
                              />
                              Upload Image
                            </Button>
                          ) : (
                            <></>
                          )}

                          {url ? (
                            <Button
                              className=" btn remove doctorupload"
                              variant="contained"
                              onClick={(e) => cancel(e)}
                              style={{
                                background: "#ef4d39",
                                color: "#fff",
                                fontSize: "11px !important",
                              }}
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                            >
                              Remove Image
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <>
                        {state.NumberCounts.Editable == 2 ||
                          // state.ClientBranchIDs.SUBROLE == 3 ||
                          EmailID == "adminit@uds.in" ||
                          EmailID == "admin@gmail.com" ||
                          EmailID == "codoid@gmail.com" ||
                          EmailID == "admin@uds.in" ? (
                          <>
                            {state.NumberCounts.EmployeeFormFIll == true ? (
                              <div
                                className="RoleButton"
                                style={{
                                  display: "flex",
                                  gap: "15px",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                  padding: "0px 15px",
                                  marginBottom: "20px",
                                }}
                              >
                                <button
                                  class="btn ButtonCSS"
                                  style={{
                                    color: "#ffff",
                                    background: "#F26239",
                                  }}
                                  onClick={(e) => {
                                    dispatch(SetActiveTabs(6));
                                  }}
                                >
                                  Previous
                                </button>
                                <button
                                  class="btn ButtonCSS"
                                  style={{
                                    color: "#ffff",
                                    background: "#EF4D39",
                                  }}
                                  onClick={(e) => {
                                    HandleNext(e);
                                  }}
                                >
                                  Save & Continue
                                </button>
                              </div>
                            ) : (
                              <>
                                {(state.NumberCounts.Editable == 1 &&
                                  state.SideBarFiles.UserEmailID ==
                                  "admin@gmail.com") ||
                                  state.SideBarFiles.UserEmailID ==
                                  "adminit@uds.in" ||
                                  state.SideBarFiles.UserEmailID ==
                                  "codoid@gmail.com" ||
                                  state.SideBarFiles.UserEmailID ==
                                  "admin@uds.in" ? (
                                  <div
                                    className="RoleButton"
                                    style={{
                                      display: "flex",
                                      gap: "15px",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                      padding: "0px 15px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <button
                                      class="btn ButtonCSS"
                                      style={{
                                        color: "#ffff",
                                        background: "#F26239",
                                      }}
                                      onClick={(e) => {
                                        dispatch(SetActiveTabs(6));
                                      }}
                                    >
                                      Previous
                                    </button>
                                    <button
                                      class="btn ButtonCSS"
                                      style={{
                                        color: "#ffff",
                                        background: "#EF4D39",
                                      }}
                                      onClick={(e) => {
                                        HandleNext(e);
                                      }}
                                    >
                                      Save & Continue
                                    </button>
                                  </div>
                                ) : null}
                              </>
                            )}
                          </>
                        ) : (state.ClientBranchIDs.SUBROLE == 3 ||
                          state.ClientBranchIDs.SUBROLE == 0 ||
                          state.ClientBranchIDs.SUBROLE == 1) &&
                          state.NumberCounts.Editable == 1 &&
                          state.NumberCounts.EmployeeFormFIll == true ? (
                          // &&
                          // PennyDropVerification == false
                          <>
                            <div
                              className="RoleButton"
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                padding: "0px 15px",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#F26239",
                                }}
                                onClick={(e) => {
                                  dispatch(SetActiveTabs(6));
                                }}
                              >
                                Previous
                              </button>
                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#EF4D39",
                                }}
                                onClick={(e) => {
                                  HandleNext(e);
                                }}
                              >
                                Save & Continue
                              </button>
                            </div>
                          </>
                        ) : null}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={DeclaationPassfile}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default DecalarationFrom;
